import { useEffect, useState } from "react";
import API from "../../../../../services/api";

const initialState = {
  packageName: "",
  description: "",
  category: "Wedding",
  foodType: "Veg",
  pricePerPlate: "",
  minimumGuests: "",
  maximumGuests: "",
  preparationTime: "",
  advanceBookingDays: "",
  menuItems: "",
  availableToday: true,
  isAvailable: true,
  image: null,
};

function useCateringForm(editingPackage, refreshPackages) {
  const [formData, setFormData] = useState(initialState);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editingPackage) {
      setFormData({
        packageName: editingPackage.packageName || "",
        description: editingPackage.description || "",
        category: editingPackage.category || "Wedding",
        foodType: editingPackage.foodType || "Veg",
        pricePerPlate: editingPackage.pricePerPlate || "",
        minimumGuests: editingPackage.minimumGuests || "",
        maximumGuests: editingPackage.maximumGuests || "",
        preparationTime: editingPackage.preparationTime || "",
        advanceBookingDays:
          editingPackage.advanceBookingDays || "",
        menuItems: editingPackage.menuItems
          ? editingPackage.menuItems.join(", ")
          : "",
        availableToday:
          editingPackage.availableToday ?? true,
        isAvailable:
          editingPackage.isAvailable ?? true,
        image: null,
      });
    } else {
      setFormData(initialState);
    }
  }, [editingPackage]);

  const updateField = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitForm = async () => {
    try {
      setLoading(true);

      const data = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (key === "menuItems") {
          value
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean)
            .forEach((item) =>
              data.append("menuItems", item)
            );
        } else if (key === "image") {
          if (value) {
            data.append("image", value);
          }
        } else {
          data.append(key, value);
        }
      });

      if (editingPackage) {
        await API.put(
          `/catering/${editingPackage._id}`,
          data
        );
      } else {
        await API.post("/catering", data);
      }

      await refreshPackages();

      return true;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    updateField,
    submitForm,
  };
}

export default useCateringForm;